import React from "react";
import { Button } from "semantic-ui-react";

const TicketFlightActionButtons = ({ setEditTicket, setEditFlight, flight, status }) => {
  const addDisruptedFlightAvailable = flight && (!flight.delayedFlight && !status)
  const addTicketDisruptionAvailable = !status
  if (!addDisruptedFlightAvailable && !addTicketDisruptionAvailable) {
    return null
  }
  return <React.Fragment>
    {addDisruptedFlightAvailable &&
     <Button
      primary
      size="mini"
      floated="right"
      name="Flight"
      style={{ marginLeft: "1rem" }}
      className="c-TicketDetails__add-btn"
      content={"Add disrupted flight"}
      onClick={setEditFlight}
      type="submit"
    />}
    {addTicketDisruptionAvailable &&
    <Button
      primary
      size="mini"
      floated="right"
      name="Ticket"
      style={{ marginLeft: "1rem" }}
      className="c-TicketDetails__add-btn"
      content={"Add ticket disruption"}
      onClick={setEditTicket}
      type="submit"
    />}
  </React.Fragment>
}

export default TicketFlightActionButtons;



// WEBPACK FOOTER //
// ./src/component/FlightView/TicketFlightActionButtons.js